import { Component } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Select from "react-select";

import type { SelectOptionItem } from "@/components/manufacturing/PlanningTable2/lineOrderList/filters/TypeFilterConsts";
import { translate } from "@/components/IntlProviderWrapper";
import * as t from "@/lib/backend/manufacturing2.generated.types";

type SelectOptions = {
    lines_options: SelectOptionItem[];
    people_options: SelectOptionItem[];
    plants_options: SelectOptionItem[];
};

export type SingleCompetence = {
    title: string;
    uuid: string;
    group_uuid: string;
    level: number;
    line_group_title: string;
    weight: number;
};
export type SingleCompetenceGroup = {
    title: string;
    uuid: string;
};

export type Props = {
    show: boolean;
    people: t.IPersonData[];
    lines: t.ILineData[];
    plants: t.IPlantData[];
    handleModalCloseClick: (do_refresh: boolean) => void;
    onSave: (lines_uuids: string[], persons_uuids: string[], plants_uuids: string[]) => void;
};

type State = {
    current_line_selected: SelectOptionItem[];
    current_person_selected: SelectOptionItem[];
    current_plant_selected: SelectOptionItem[];
};

class PeopleExportCompetencesModal extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const state: State = {
            current_line_selected: [],
            current_person_selected: [],
            current_plant_selected: [],
        };
        this.state = state;
    }

    getSelectOptions = () => {
        const { lines, people, plants } = this.props;
        const select_options: SelectOptions = { lines_options: [], people_options: [], plants_options: [] };
        for (const line of lines) {
            select_options.lines_options.push({ value: line.uuid, label: line.title });
        }
        for (const person of people) {
            select_options.people_options.push({ value: person.uuid, label: person.name });
        }
        for (const plant of plants) {
            select_options.plants_options.push({ value: plant.uuid, label: plant.title });
        }
        return select_options;
    };

    onChangeLine = (selected: SelectOptionItem[]) => {
        this.setState({ current_line_selected: selected });
    };

    onChangePerson = (selected: SelectOptionItem[]) => {
        this.setState({ current_person_selected: selected });
    };

    onChangePlant = (selected: SelectOptionItem[]) => {
        this.setState({ current_plant_selected: selected });
    };

    onSave = () => {
        this.props.onSave(
            this.state.current_line_selected.map(item => item.value),
            this.state.current_person_selected.map(item => item.value),
            this.state.current_plant_selected.map(item => item.value)
        );
    };

    render() {
        const { handleModalCloseClick } = this.props;
        const { lines_options, people_options, plants_options } = this.getSelectOptions();
        return (
            <Modal
                show={this.props.show}
                dialogClassName="modal-dialog-scrollable"
                onHide={() => handleModalCloseClick(false)}
            >
                <Modal.Header>
                    <Modal.Title>
                        <FormattedMessage
                            id="Manufacturing.People.export_all_persons_competences"
                            defaultMessage="Export all persons competences"
                        />
                    </Modal.Title>
                    <button type="button" className="close" onClick={() => handleModalCloseClick(true)}>
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">
                            <FormattedMessage id="common.close" defaultMessage="Close" />
                        </span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <span className="gray">
                        {translate(
                            "Manufacturing.People.leave_empty_for_whole_org",
                            "Leave empty to select data for whole organization"
                        )}
                    </span>
                    <div className="space20" />
                    <Select
                        classNamePrefix="react-select"
                        options={lines_options}
                        value={this.state.current_line_selected}
                        onChange={this.onChangeLine}
                        placeholder={translate("Manufacturing.Lines.all_lines", "All lines")}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        isMulti
                        closeMenuOnSelect={false}
                        styles={{
                            menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                    <div className="space20" />
                    <Select
                        classNamePrefix="react-select"
                        options={people_options}
                        value={this.state.current_person_selected}
                        onChange={this.onChangePerson}
                        placeholder={translate("Manufacturing.People.all_people", "All people")}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        isMulti
                        closeMenuOnSelect={false}
                        styles={{
                            menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                    <div className="space20" />
                    <Select
                        classNamePrefix="react-select"
                        options={plants_options}
                        value={this.state.current_plant_selected}
                        onChange={this.onChangePlant}
                        placeholder={translate("Manufacturing.Lines.all_plants", "All plants")}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        isMulti
                        closeMenuOnSelect={false}
                        styles={{
                            menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={this.onSave}>
                        <FormattedMessage id="common.export" defaultMessage="Export" />
                    </button>
                    <button className="btn btn-outline-secondary" onClick={() => handleModalCloseClick(false)}>
                        <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default PeopleExportCompetencesModal;
